module.exports = __webpack_public_path__ + "img/2882922-68-9.b4a9d340.png";